// src/pages/SuccessPage.js
import React from "react";
import { useEffect } from "react";
const SuccessPage = () => {

useEffect(() => {
        // Optional: Analytics or toast notification
}, []);

      
  return (
    <div style={styles.container}>
      <h1 style={styles.heading}>🎉 Subscription Successful!</h1>
      <p style={styles.message}>Thank you for subscribing to <strong>Lead Amplify</strong>!</p>
      <a href="/" style={styles.link}>← Back to Dashboard</a>
    </div>
  );
};

const styles = {
  container: {
    textAlign: "center",
    padding: "3rem 1.5rem",
    fontFamily: "Arial, sans-serif",
    backgroundColor: "#f9f9f9",
    minHeight: "100vh",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  },
  heading: {
    color: "#28a745",
    fontSize: "2rem",
    marginBottom: "1rem",
  },
  message: {
    fontSize: "1.125rem",
    color: "#333",
    marginBottom: "2rem",
  },
  link: {
    display: "inline-block",
    backgroundColor: "#007bff",
    color: "white",
    padding: "0.75rem 1.5rem",
    borderRadius: "6px",
    textDecoration: "none",
    fontWeight: "bold",
    transition: "background-color 0.3s ease",
  },
};

export default SuccessPage;
